export default "__VITE_ASSET__DHqTxGMX__"